module.exports = __webpack_public_path__ + "img/oversight.bc9a9ded.png";